"use client";

import { c as _c } from "react/compiler-runtime";
import { lazy, Suspense, useEffect, useState, useCallback, useRef } from "react";
const ErrorDialog = lazy(() => import("@/app/components/ErrorDialog/ErrorDialog"));
import { Stepper } from "@/app/components/Stepper/Stepper";
import useErrorDialogConfig from "@/lib/hooks/useErrorDialogConfig";
import { useSchedulerActor, useSchedulerSelector } from "@/lib/hooks/useSchedulerMachine";
import { getEligibilityBlock } from "@/lib/machines/utils/patientEligibility";
import { dataLayerPushExistingAccount } from "@/lib/utils/modalDataLayerPush";
export default function SchedulerContent() {
  const $ = _c(28);
  const actorRef = useSchedulerActor();
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const facility = useSchedulerSelector(_temp);
  const resp = useSchedulerSelector(_temp2);
  const errorsErrorCode = useSchedulerSelector(_temp3);
  const phoneNumber = facility?.phoneNumber ?? "";
  const webFacilityDetails = facility;
  let t0;
  if ($[0] !== resp) {
    t0 = getEligibilityBlock(resp);
    $[0] = resp;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const eligibilityBlock = t0;
  const errorCode = eligibilityBlock ?? errorsErrorCode ?? "";
  const dialogBodyRef = useRef(undefined);
  let t1;
  if ($[2] !== actorRef || $[3] !== errorCode || $[4] !== resp || $[5] !== webFacilityDetails) {
    t1 = () => {
      dataLayerPushExistingAccount("dismiss", webFacilityDetails, resp, errorCode, dialogBodyRef.current);
      setErrorDialogOpen(false);
      actorRef.send({
        type: "CLEAR_ERROR"
      });
    };
    $[2] = actorRef;
    $[3] = errorCode;
    $[4] = resp;
    $[5] = webFacilityDetails;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const handleClose = t1;
  const dialogConfig = useErrorDialogConfig(errorCode, phoneNumber, handleClose);
  let t2;
  if ($[7] !== dialogConfig?.body) {
    t2 = () => {
      dialogBodyRef.current = dialogConfig?.body;
    };
    $[7] = dialogConfig?.body;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = dialogConfig?.body;
  let t4;
  if ($[9] !== t3) {
    t4 = [t3];
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  useEffect(t2, t4);
  let t5;
  if ($[11] !== dialogConfig?.body || $[12] !== errorCode || $[13] !== resp || $[14] !== webFacilityDetails) {
    t5 = () => {
      if (errorCode) {
        setErrorDialogOpen(true);
        if (errorCode === "existingPatient_with_appt" || errorCode === "existingPatient_no_appt" || errorCode === "newPatient_with_appt" || errorCode === "Schedule_PatientHasFutureAppointments" || errorCode === "Schedule_NotNewPatient" || errorCode === "TU_FAIL") {
          dataLayerPushExistingAccount("not selected", webFacilityDetails, resp, errorCode, dialogConfig?.body);
        }
      }
    };
    $[11] = dialogConfig?.body;
    $[12] = errorCode;
    $[13] = resp;
    $[14] = webFacilityDetails;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const t6 = dialogConfig?.body;
  let t7;
  if ($[16] !== errorCode || $[17] !== resp || $[18] !== t6 || $[19] !== webFacilityDetails) {
    t7 = [errorCode, resp, webFacilityDetails, t6];
    $[16] = errorCode;
    $[17] = resp;
    $[18] = t6;
    $[19] = webFacilityDetails;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  useEffect(t5, t7);
  let t8;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Stepper />;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== dialogConfig || $[23] !== errorDialogOpen || $[24] !== handleClose) {
    t9 = dialogConfig && <ErrorDialog iconColor={dialogConfig.iconColor} open={errorDialogOpen} onClose={handleClose} title={dialogConfig.title} body={dialogConfig.body} buttons={dialogConfig.buttons} />;
    $[22] = dialogConfig;
    $[23] = errorDialogOpen;
    $[24] = handleClose;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t9) {
    t10 = <>{t8}<Suspense fallback={null}>{t9}</Suspense></>;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}
function _temp3(s_1) {
  return s_1.context.errors.errorCode;
}
function _temp2(s_0) {
  return s_0.context.validatedPatientResponse;
}
function _temp(s) {
  return s.context.facility;
}